// Reusable "Download Company Profile" button.
// Points to the PDF served from /public/documents/.
import { Download } from "lucide-react";

export const COMPANY_PROFILE_PDF = "/documents/nago-international-company-profile.pdf";

export default function DownloadProfileButton({
  variant = "primary",
  size = "md",
  label = "Download Company Profile",
  className = "",
  testId = "download-profile-btn",
}) {
  const base =
    "inline-flex items-center justify-center gap-2 font-semibold rounded-lg transition-all duration-200 active:scale-[0.98]";
  const sizes = {
    sm: "px-4 py-2 text-xs",
    md: "px-5 py-2.5 text-sm",
    lg: "px-6 py-3 text-sm sm:text-base",
  };
  const variants = {
    primary:
      "bg-[#E30613] text-white hover:bg-[#C80511] hover:shadow-lg hover:-translate-y-0.5",
    outline:
      "border-2 border-[#1E3A8A] text-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white",
    ghost:
      "border border-slate-300 text-slate-700 bg-white hover:border-[#1E3A8A] hover:text-[#1E3A8A]",
    "light-outline":
      "border-2 border-white text-white hover:bg-white hover:text-[#1E3A8A]",
  };
  return (
    <a
      href={COMPANY_PROFILE_PDF}
      download="Nago-International-Company-Profile.pdf"
      target="_blank"
      rel="noreferrer"
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      data-testid={testId}
    >
      <Download className="w-4 h-4" />
      <span>{label}</span>
    </a>
  );
}
